module.exports = __webpack_public_path__ + "vue_assets/img/img_deios_background.3a8d327d.png";